import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

class OrderTotal extends React.Component {
    static propTypes = {
        total: PropTypes.object.isRequired,
        tax_totals: PropTypes.array.isRequired,
        currency_abrv: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
    };

    getTaxTotals = () => {
        const { t } = this.props;
        const taxes = _.filter(
            this.props.tax_totals,
            tax => tax.total.toFloat() > 0
        );
        if (taxes.length === 0) {
            return null;
        }
        return (
            <span className="m2g-order-confirmation-tax m2g-text--offset m2g-text--vertical-align-middle">
                &nbsp;incl.&nbsp;
                {taxes.map(
                    (tax, i) =>
                        `${i > 0 ? ', ' : ''}${t('common:price', {
                            price: tax.total,
                        })} ${tax.name}`
                )}
            </span>
        );
    };

    render() {
        const { t, total, currency_abrv } = this.props;
        return (
            <tr className="m2g-order-confirmation-item m2g-order-confirmation-total">
                <td className="m2g-order-confirmation-item-thumbnail" />

                <td className="m2g-order-confirmation-item-content">
                    <span>{t('order_total', { currency_abrv })}</span>
                    {this.getTaxTotals()}
                </td>

                <td className="m2g-order-confirmation-item-total">
                    {t('common:price', { price: total })}
                </td>
            </tr>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(OrderTotal);
